export const hideLoader = () => {
  // Hide loader
  const loadingContainer = document.getElementById('loading-container')
  loadingContainer?.remove()
}
